export enum RightSidebarTabsEnum {
  notifications = 'notifications',
  checklist = 'checklist',
  notes = 'notes',
}
